import { baseEnvironment } from "./environment.base";

export const environment = {
	...baseEnvironment,
	production: false,
	AZURE_CLIENT_ID: "19769e0f-700c-4a0e-b040-1a13a0acf312",
	urlClientApp: "https://coreautomatizaciones-dev.ipt.pe",
	urlPortalOrigin: "https://portal-softlab-dev.ipt.pe",
	authProvider: "ipt-auth",
	urlBackendAuth: "https://authorization-api-dev.ipt.pe",
	urlBackendPortal: "https://authorization-api-dev.ipt.pe",
	urlBackendAlarmsEvents: "https://alarmas-eventos-dev.ipt.pe",
	urlBackendFlujoBajas: "https://core-automatizaciones-dev.ipt.pe",
	urlEventosCampos: "https://eventos-campos-dev.ipt.pe",
	urlApiGateway: "https://api-inventory-dev.ipt.pe",
	topologyToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InVzZXJfYXBpIiwibmFtZSI6IlVzZXIgQVBJIn0.1pz5m2gTdl8gGo3GsmTbiTD8xqCBnKJ_is0c3FE0mOQ",
	urlApiTopology: "https://topologias-backend-dev.ipt.pe",
	urlApiInventory: "https://inventario-sites-dev.ipt.pe",
	NEXT_PUBLIC_GA_MEASUREMENT_ID: "G-R0GBJS75S0",
	GA_API_SECRET: "Jq-OMXr2QTS0xGgVobwRZA",
};
